export default {
    path: '/businessDepartment',
    redirect: '/businessDepartment/customer/list',
    meta: {
        title: "经营部",
        permissionCode:"pcBusiness"
    },
    children: [{
        path: 'customer/list',
        name: 'customerList',
        component: () => import("@/views/businessDepartment/customer/list/index.vue"),
        meta: {
            permissionCode: "pcBusinessCustomerList",
            title: '客户信息管理',
            keepAlive:true,
            name:"pcBusinessCustomerList",
        },
    },
    {
        path: 'customer/create',
        name: 'customerCreate',
        component: () => import("@/views/businessDepartment/customer/create/index.vue"),
        meta: {
            permissionCode: "pcBusinessCustomerListEdit",
            title: '客户信息新增/编辑',
            needNotice: true,
            keepAlive:true,
            name:"pcBusinessCustomerListForm",
        },
    },
    {
        path: 'customer/details',
        name: 'customerDetails',
        component: () => import("@/views/businessDepartment/customer/details/index.vue"),
        meta: {
            title: "客户信息详情",
            permissionCode:"pcBusinessCustomerListAuth",
          },
    },{
        path: 'project/list',
        name: 'projectList',
        component: () => import("@/views/businessDepartment/project/list/index.vue"),
        meta: {
            permissionCode: "pcBusinessProjectList",
            title: '项目投标信息管理',
            keepAlive: true,
            name:"pcBusinessProjectList"
        },
    },
    {
        path: 'project/create',
        name: 'projectCreate',
        component: () => import("@/views/businessDepartment/project/create/index.vue"),
        meta: {
            permissionCode: "pcBusinessProjectListEdit",
            title: '项目投标信息新增/编辑',
            keepAlive: true,
            name:"pcBusinessProjectListForm"
        },
    },
    {
        path: 'project/details',
        name: 'projectDetails',
        component: () => import("@/views/businessDepartment/project/details/index.vue"),
        meta: {
            title: "项目投标信息管理",
            permissionCode:"pcBusinessProjectListDetail"
          },
    },
    {
        path: 'baseData/list',
        name: 'baseDataList1',
        component: () => import("@/views/businessDepartment/baseData/list/index.vue"),
        meta: {
            permissionCode: "pcBusinessBaseDataList",
            title: '基础信息配置',
            keepAlive:true
        },
    },
    {
        path: 'projectSettleAccountsManage/list',
        name: 'projectSettleAccountsManageList',
        component: () => import("@/views/businessDepartment/projectSettleAccountsManage/list.vue"),
        meta: {
            permissionCode: "pcBusinessProjectSettleAccountsManageList",
            title: '项目结算管理',
            keepAlive:true,
            name:"pcBusinessProjectSettleAccountsManageList"
        },
    },
    {
        path: 'projectSettleAccountsManage/details',
        name: 'projectSettleAccountsManageDetails',
        component: () => import("@/views/businessDepartment/projectSettleAccountsManage/details.vue"),
        meta: {
            permissionCode: "pcBusinessProjectSettleAccountsManageList",
            title: '项目结算管理',
           
            
        },
    }]
}